module.exports = __webpack_public_path__ + "img/l2.5477d20c.png";